import { ErrorMessage } from '@hookform/error-message';
import { Box } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';

import { QuestionType } from '~/data/surveys';

import {
  FreeText,
  MultipleChoice,
  Scale,
  SingleChoice,
  YesNo,
} from '../../FormFields';
import { AnswerPreProcess, SurveyQuestion } from '../../types';
import { useSxStyles } from '../useStyles';

type Props = {
  questions: SurveyQuestion[];
  control: Control<AnswerPreProcess>;
  errors: FieldErrors<AnswerPreProcess>;
};

export const SurveyForm: React.FC<Props> = ({ questions, control, errors }) => {
  const sxStyles = useSxStyles();

  const getQuestion = (question: SurveyQuestion) => {
    switch (question.type) {
      case QuestionType.FREE_TEXT:
        return (
          <FreeText question={question} control={control} errors={errors} />
        );

      case QuestionType.MULTIPLE_CHOICE:
        return (
          <>
            <MultipleChoice question={question} control={control} />
            <ErrorMessage
              errors={errors}
              name={`${question.id}`}
              render={({ message }) => (
                <Box component="span" sx={sxStyles.error}>
                  {message}
                </Box>
              )}
            />
          </>
        );

      case QuestionType.YES_NO:
        return (
          <>
            <YesNo question={question} control={control} />
            <ErrorMessage
              errors={errors}
              name={`${question.id}`}
              render={({ message }) => (
                <Box component="span" sx={sxStyles.error}>
                  {message}
                </Box>
              )}
            />
          </>
        );
      case QuestionType.SCALE:
        return (
          <>
            <Scale question={question} control={control} />
            <ErrorMessage
              errors={errors}
              name={`${question.id}`}
              render={({ message }) => (
                <Box component="span" sx={sxStyles.error}>
                  {message}
                </Box>
              )}
            />
          </>
        );
      case QuestionType.SINGLE_CHOICE:
        return (
          <>
            <SingleChoice question={question} control={control} />
            <ErrorMessage
              errors={errors}
              name={`${question.id}`}
              render={({ message }) => (
                <Box component="span" sx={sxStyles.error}>
                  {message}
                </Box>
              )}
            />
          </>
        );
    }
  };

  return (
    <form>
      {questions.map((question, idx) => {
        return <div key={idx}> {getQuestion(question)}</div>;
      })}
    </form>
  );
};
